import { FragranceOption } from './types';

export const fragranceMustOptions: FragranceOption[] = [
  {
    name: 'topics:fragrance:options:mustComply:noAllergensOnOil',
    value: 'noAllergensOnOil',
  },
  {
    name: 'topics:fragrance:options:mustComply:noAllergensOnFinalProduct',
    value: 'noAllergensOnFinalProduct',
  },
  {
    name: 'topics:fragrance:options:mustComply:pCMNMFree',
    value: 'pCMNMFree',
  },
  {
    name: 'topics:fragrance:options:mustComply:ecoLabel',
    value: 'ecoLabel',
  },
  {
    name: 'topics:fragrance:options:mustComply:okotestCandidate',
    value: 'okotestCandidate',
  },
  {
    name: 'topics:fragrance:options:mustComply:vegan',
    value: 'vegan',
  },
  {
    name: 'topics:fragrance:options:mustComply:other',
    value: 'other',
  },
];
